export default {
  data () {
    return {
      columns: [
        {
          title: 'id',
          type: 'index'
        }, {
          title: '用户名',
          key: 'name'
        }, {
          title: '手机号',
          key: 'mobile'
        }, {
          title: '邮箱',
          key: 'email'
        },
        /*
        {
          title: '部门',
          key: 'dept'
        }, {
          title: '拓展字段',
          key: 'extend'
        }, {
          title: '地址',
          key: 'addr'
        },
        */
        {
          title: '创建时间',
          key: 'createTimeStr'
        }, {
          title: '创建人',
          key: 'createName'
        }, {
          title: '更新时间',
          key: 'updateTimeStr'
        }, {
          title: '更新人',
          key: 'updateName'
        }, {
          name: 'action',
          title: '操作',
          render: (h, params) => {
            let booleanStatus = params.row.status === 'Y'
            let that = this
            return (
              <div>
                <i-switch size="large" v-model={booleanStatus} onOn-change={that.changeStatus.bind(that, params)}>
                  <span slot="open">启用</span>
                  <span slot="close">禁用</span>
                </i-switch>
                <i-button type="primary" size="small" loading={that.submitLoading}
                          nativeOnClick={that.resetPassword.bind(that, params)}>重置密码
                </i-button>
              </div>

            )
          }
        }
      ]
    }
  }
}
